module.exports = __webpack_public_path__ + "img/painPerceptionScale_8_w.a0bf988d.png";